import { forwardRef } from 'react';

interface HrProps {
  text?: string;
  color?: string;
  className?: string;
}

const Hr = forwardRef(({ text, color, className }: HrProps, ref?: any) => {
  text = text ? text : '';
  color = color ? color : 'red-200';

  return (
    <div ref={ref} className={`flex w-full items-center ${className}`}>
      <div className={`flex-1 border border-t border-${color} `}></div>
      <div className={`{px-2 mx-4 text-${color}`}>{text}</div>
      <div className={`flex-1 border border-t border-${color} `}></div>
    </div>
  );
});

export default Hr;
